import { SensorDisplayCoreObject } from './SensorDisplayCoreObject';
import * as settings from '../common/settings';
import { IObjectsPool, IMapMngr } from './interfaces';
import { ObjectsDrawer } from './ObjectsDrawer';
import { AspObject } from './AspObject';
import { DisplayObject } from './DisplayObject';

const sensorTemplate = 
  [
    { // 0 - DB main leader
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbMainLeader"
    },
    { // 1 - Symbol
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0, },
      "minSize": { "width": 45, "height": 45 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "SensorSymbol"
    },
    { // 2 - DB main area
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [ 0 ],
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0.5, "vertical": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbMain"
    },
    { // 3 - name
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [ 2 ],
      "offset": { "x": 4, "y": 15 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": -0.5 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Name"
    },
    { // 4 - id
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [ 2 ],
      "offset": { "x": 4, "y": -6 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": 0.5 },
      "alignment": { "horizontal": 0.5, "vertical": -0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Id"
    },
    { // 5 - hook
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [1],
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0, "vertical": 0 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "HookCircle"
    },
  ];

const itemsProperties = [ // elements per template
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha, // horiz DB leader
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha, // symbol
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha, // DB main area
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha, // name
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha, // id
  null, // hook
];

const drawFlags = [ // elements per template
  { scale: 100000, flags: [true, true, true, true, true, true] },
  { scale: 2000000, flags: [true, true, true, true, true, true] },
  { scale: Number.MAX_VALUE, flags: [false, true, false, false, false, true] }
  // { scale: Number.MAX_VALUE, flags: [true, true, true, true, true, true] }
];

const symbolNames = [
  'radar',
  'building',
  'video',
  'sound-sns'
];

const miscSymbolNames = [
  'hook-circle',
  'sensor-db-main-bg',
  'sensor-db-horiz-leader',
];

const imagesToLoad = ObjectsDrawer.initImagesToLoad(miscSymbolNames, symbolNames);

export class SensorsCoreDrawer extends ObjectsDrawer {

  constructor(mapMngr: IMapMngr, objectsPool: IObjectsPool, parentLayer) {
    super(mapMngr, objectsPool, settings.DisplayFilter.Sensors, parentLayer, sensorTemplate,
      imagesToLoad, drawFlags, itemsProperties);
  }

  protected templateStyles(images): any[] {
    let imageStyle = new NeWMI.Draw.Styles.ImagesFontStyle({ images: images });
    // elements per template
    return [
      imageStyle,
      imageStyle,
      imageStyle,
      this.is3D() ? this.normal3DTextStyle : this.smallTextStyle,
      this.is3D() ? this.normal3DTextStyle : this.smallTextStyle,
      imageStyle];
  }

  protected allImagesLoaded(images) {
    images['hook-circle'].size = { width: 40, height: 40 };

    for (let symbol of symbolNames) {
      images[symbol].size = { width: 25, height: 25 };
    }
    super.allImagesLoaded(images);
  }

  // Override ObjectsDrawer
  createDisplayObject(obj: any): DisplayObject {
    return new SensorDisplayCoreObject(obj, this);
  }

  // Override ObjectsDrawer
  getOpacity(): number {
    // return settings.userSettings.pointOpacity;
    return 1;
  }
}

